import { EMPTY_FINANCIAL_REPORT_MODEL } from "presentation/model/FinancialReport/FinancialReportModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: FinancialReportProvider,
    useTracked: useFinancialReportTracked
} = createContainer(() => useState(EMPTY_FINANCIAL_REPORT_MODEL), {concurrentMode: true});
export { FinancialReportProvider, useFinancialReportTracked };
